// Shared comparator for purchase order line items — every list of
// procurement items (the create/edit form, the read-only view, the detail
// drawer, the receive-items dialog) shows them alphabetically by product
// name, ascending, so staff always find a line the same way regardless of
// which screen they're on.
export function compareByProductName<
    T extends { product?: { name?: string | null } | null },
>(a: T, b: T): number {
    return (a.product?.name || "").localeCompare(b.product?.name || "");
}
